// Words / patterns that must never appear as a Google Ads asset value
// (headline, description, callout, sitelink text). These are UI section
// labels + common misspellings we've seen leak into real CSV exports.
// Both trustCopy.js's router and csv.js's merger filter against this set
// so the guard is redundant on purpose.
//
// The Set is immutable: mutating methods are stubbed to no-ops BEFORE
// Object.freeze so a stray .add()/.delete() from a future caller can't
// silently drift the guard.  Object.freeze alone does NOT protect Set
// instances (add/delete/clear live on the prototype, not the instance).
const _rawStopLabels = new Set([
    // Correct spellings
    "headline", "headlines",
    "description", "descriptions",
    "callout", "callouts",
    "sitelink", "sitelinks",
    "keyword", "keywords",
    "negative", "negatives",
    // Common single-letter typos users have reported in real exports
    "decription", "decriptions",       // missing 's'
    "descripton", "descriptons",       // missing 'i'
    "descripion", "descripions",       // missing 't'
    "headine", "headines",             // missing 'l'
    "calout", "calouts",               // missing 't'
    "sitelnk", "sitelnks",             // missing 'i'
    // Common column-header labels
    "text", "value", "asset", "field", "type", "column",
]);

const _noop = () => _rawStopLabels;
Object.defineProperty(_rawStopLabels, "add", { value: _noop, writable: false, configurable: false });
Object.defineProperty(_rawStopLabels, "delete", { value: () => false, writable: false, configurable: false });
Object.defineProperty(_rawStopLabels, "clear", { value: _noop, writable: false, configurable: false });

export const AD_ASSET_STOP_LABELS = Object.freeze(_rawStopLabels);
